import { useEffect, useState } from 'react';
import { PolicyStatus } from '@jove-frontend/uikit';
import clsx from 'clsx';
import { capitalize } from 'lodash';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var PolicyStatusViewTypeEnum;

(function (PolicyStatusViewTypeEnum) {
  PolicyStatusViewTypeEnum["quote"] = "quote";
  PolicyStatusViewTypeEnum["cms"] = "cms";
  PolicyStatusViewTypeEnum["validation"] = "validation";
})(PolicyStatusViewTypeEnum || (PolicyStatusViewTypeEnum = {}));

var PolicyStatusView = function PolicyStatusView(props) {
  var className = props.className,
      _props$type = props.type,
      type = _props$type === void 0 ? PolicyStatusViewTypeEnum.quote : _props$type,
      label = props.label,
      color = props.color,
      status = props.status;

  var _useState = useState({}),
      containerStyle = _useState[0],
      setContainerStyle = _useState[1];

  var _useState2 = useState(''),
      showText = _useState2[0],
      setShowText = _useState2[1];
  /**
   * effects
   */


  useEffect(function () {
    evaluateTextInfo();
  }, [status]);
  /**
   * methods
   */

  var evaluateTextInfo = function evaluateTextInfo() {
    var textColor = color;
    var showText = label || '';

    if (!textColor) {
      switch (status) {
        case PolicyStatus.POLICY_CANCEL_INITIATED:
        case PolicyStatus.POLICY_CANCELLED:
        case PolicyStatus.POLICY_CANCEL_CONFIRMED:
          textColor = '#DD1F1F';
          break;

        case PolicyStatus.POLICY_PAUSE_EXTENDED:
        case PolicyStatus.POLICY_PAUSE_INITIATED:
        case PolicyStatus.POLICY_PAUSE_PLANNED:
          textColor = '#43A7D2';
          break;

        case PolicyStatus.POLICY_RENEW_TRIGGER:
        case PolicyStatus.POLICY_RENEWED_INITIATED:
        case PolicyStatus.POLICY_RENEWED_UPDATE_REFERRAL:
        case PolicyStatus.POLICY_UPDATE_REFERRAL:
          textColor = '#E76F2B';
          break;

        case PolicyStatus.POLICY_ELAPSED:
          textColor = '#999999';
          break;

        default:
          textColor = '#1CB258';
          break;
      }
    }

    if (!label) {
      showText = status;
    }

    setShowText(showText);
    setContainerStyle({
      backgroundColor: "".concat(textColor)
    });
  };

  return /*#__PURE__*/_jsxs("div", {
    className: clsx('inline-flex flex-row items-center space-x-1', className),
    children: [/*#__PURE__*/_jsx("div", {
      style: containerStyle,
      className: "h-2 w-2 rounded-full"
    }), /*#__PURE__*/_jsx("span", {
      className: "flex-1 font-medium text-[#202020]",
      children: capitalize(showText === null || showText === void 0 ? void 0 : showText.replaceAll('_', ' '))
    })]
  });
};

export default PolicyStatusView;